import { render, staticRenderFns } from "./ProcessAtribute.vue?vue&type=template&id=021d9303"
import script from "./ProcessAtribute.vue?vue&type=script&lang=js"
export * from "./ProcessAtribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports